function set_auto_width() {
    var isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i);
    if ($('.cs-option-box').length) {

        $('.desktop-enquiry .cs-option-box').html('<option>' + $('.desktop-enquiry .url-option-1:visible option:selected').val() + '</option>');
        $('.desktop-enquiry .cs-option-box').css('font-size', $('.desktop-enquiry .url-option-1:visible').css('font-size'));
        var custom_width = $('.desktop-enquiry .cs-option-box').width() + 40;
        $('.desktop-enquiry .url-option-1:visible').css('width', custom_width);


        //$('.desktop-enquiry').remove();
        $('.mobile-enquiry .cs-option-box').html('<option>' + $('.mobile-enquiry .url-option-1:visible option:selected').val() + '</option>');
        $('.mobile-enquiry .cs-option-box').css('font-size', $('.mobile-enquiry .url-option-1:visible').css('font-size'));
        var mobile_custom_width_1 = $('.mobile-enquiry .cs-option-box').width() + 40;
        $('.mobile-enquiry .url-option-1:visible').css('width', mobile_custom_width_1);

        $('.mobile-enquiry .cs-option-box').html('<option>' + $('.mobile-enquiry .url-option-2 option:selected').text() + '</option>');
        $('.mobile-enquiry .cs-option-box').css('font-size', $('.mobile-enquiry .url-option-2').css('font-size'));
        var mobile_custom_width_2 = $('.mobile-enquiry .cs-option-box').width() + 40;
        $('.mobile-enquiry .url-option-2').css('width', mobile_custom_width_2);

    }
}
function stick_filter(){
  if($('.custom-sticky-filter').length){
    $('.custom-sticky-filter').html($('.original-filter').html());
  }
}

jQuery(window).on('load', function () {
  $(document).on('change','.custom-sticky-filter .SortBy',function(){
    $('.original-filter .SortBy').val($(this).val());
    $('.original-filter .SortBy').trigger('change');
  });
  
  $(document).on('change','.custom-sticky-filter .SortTags',function(){
    $('.original-filter .SortTags').val($(this).val());
    $('.original-filter .SortTags').trigger('change');
  });
if($(".collection-local-menu li a.active").length){
  $(".list-view-items > .list-view-item").sort(sort_tag_li).appendTo('.list-view-items');
  function sort_tag_li(a, b) {
    return ($(b).data('position')) > ($(a).data('position')) ? 1 : -1;
  }
  }
  stick_filter();
    set_auto_width();
    $("body").removeClass('loading');

    var gclid = getParam("gclid");
    if (gclid) {
        setCookie("gclid", gclid, 1);
    }
    gclid = getCookie("gclid");

    if (gclid) {
        $(".rfq_form .google-adwords input").val(gclid);
    }
    utm_source = getCookie("_uc_utm_source");  
    if (utm_source) {
        $(".rfq_form .google-adwords input").val(utm_source);
    }
  //BING
  var msclkid = getParam("msclkid");
    if (msclkid) {
        setCookie("msclkid", msclkid, 1);
    }
    msclkid = getCookie("msclkid");

    if (msclkid) {
        $(".rfq_form .bing-adwords input").val(msclkid);
    }

  if(window.location.pathname.match('/pages/request-for-quote-submitted')){
    setCookie("msclkid", '', 0);
    setCookie("gclid", '', 0);
  }  
    
    if ($(window).width() < 768) {
        mobile_menu_max_height();
    }
    $(window).scroll(function () {
        if ($(window).width() < 768) {
            mobile_menu_max_height();
        }
    });
    $(window).resize(function () {
        mobile_menu_max_height();
    });

});

function mobile_menu_max_height() {
    if ($(window).width() < 768) {
        $('.mobile-nav-wrapper').css('max-height', $(window).height() - $('.site-header').height());
    }
}
jQuery(document).ready(function () {

    $('.site-loader .la-anim-1').addClass('la-animate');
    if ($("#load_more_product").length > 0) {
        $(window).scroll(function () {
            $.doTimeout('scroll', 200, ScrollExecute);
        });
    }

  $('.home-slider1-column .owl-carousel').owlCarousel({
    loop:true,
    animateOut: 'fadeOut',
    autoplay:true,
    responsiveClass:true,
    autoplayTimeout:5000,
    dots:false,
    responsive:{
        0:{
            items:1,
            nav:false
        },        
        992:{
            items:1,
            nav:false,
          
        }
    }
});
  $('.home-slider2-column .owl-carousel').owlCarousel({
    loop:true, 
    animateOut: 'fadeOut',
    autoplay:true,
    responsiveClass:true,
    autoplayTimeout:7000,
    dots:false,
    responsive:{
        0:{
            items:1,
            nav:false
        },        
        992:{
            items:1,
            nav:false            
        }
    }
});
  $('.home-slider3-column .owl-carousel').owlCarousel({
    loop:true,  
    animateOut: 'fadeOut',
    autoplay:true,
    dots:false,
    autoplayTimeout:9000,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:false
        },        
        992:{
            items:1,
            nav:false            
        }
    }
});

    $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll >= $("#shopify-section-header").height()) {
            $("#shopify-section-header").addClass("sticky");
            $("body").addClass("sticky-nav");
        } else {
            $("#shopify-section-header").removeClass("sticky");
            $("body").removeClass("sticky-nav");
        }
    });


    $(".filter-url-form .url-option-1, .mobile-enquiry .url-option-2").on('change', function (e) {
        set_auto_width();
        if ($(this).val() == 'home-office') {
            $(".filter-url-form .home-office-hide").hide();
            $(".filter-url-form .url-option-2").val('chairs');
        } else {
            $(".filter-url-form .home-office-hide").show();
        }
    });

    $(".filter-url-form .btn").on('click', function (e) {
        var option1 = $(".filter-url-form .url-option-1").val();
        var option2 = $(".filter-url-form .url-option-2").val();
        var value = option1 + '-' + option2;

        var collectionsArray = {
            "business-chairs": "/collections/business-chairs",
            "business-sit-stand": "/collections/business-height-adjustable-desks",
            "business-desks": "/collections/business-desks",
            "business-workstations": "/collections/business-workstations",
            "business-tables": "/collections/business-tables",
            "business-whiteboards": "/collections/business-whiteboards-presentation",
            "business-filing-cabinets": "/collections/business-filing-cabinets-and-storage",
            "business-screens": "/collections/business-screens-and-partitioning",
            "business-covid-19": "/collections/business-covid-19-products",
            "school-chairs": "/collections/school-chairs",
            "school-sit-stand": "/collections/school-height-adjustable-desks",
            "school-desks": "/collections/school-desks",
            "school-workstations": "/collections/school-workstations",
            "school-tables": "/collections/school-tables",
            "school-whiteboards": "/collections/school-whiteboards-presentation",
            "school-filing-cabinets": "/collections/school-filing-cabinets-and-storage",
            "school-screens": "/collections/school-screens-and-partitioning",
            "school-covid-19": "/collections/school-covid-19-products",
            "home-office-chairs": "/collections/home-office-chairs",
            "home-office-sit-stand": "/collections/home-office-height-adjustable-desks",
            "home-office-desks": "/collections/home-office-desks",
            "home-office-workstations": "/collections/home-office-workstations",
            "home-office-tables": "/collections/home-office-tables",
            "home-office-whiteboards": "/collections/home-office-whiteboards-presentation",
            "home-office-filing-cabinets": "/collections/home-office-filing-cabinets-and-storage",
            "home-office-screens": "/collections/home-office-screens-and-partitioning",
            "home-office-covid-19": "/collections/home-office-covid-19-products"
        };
        window.location.href = collectionsArray[value];
        e.preventDefault();
    });


});
$(window).load(function () {
    $(".jdgm-subtab__name[data-tabname='product-reviews']").hide();
    $(".jdgm-subtab__name[data-tabname='shop-reviews']").trigger('click');
    if ($(".jdgm-subtab__name[data-tabname='shop-reviews']").length) {
        var html = $(".jdgm-subtab__name[data-tabname='shop-reviews']").html().replace("Shop", "");
        $(".jdgm-subtab__name[data-tabname='shop-reviews']").html(html);
    }

    $("#shopify-section-list-collections-template .grid__item .collection-grid-item__title").each(function () {
        var title = $.trim($(this).text());
        if (title == "Tables" || title == "Your collection's name" || title == "Office Chairs") {
            $(this).parents(".grid__item").remove();
        }
    });

    if ($(window).width() > 1024) {
        $('.product-popover-hover').imageTooltip();
    }

    $('.site-loader').fadeOut();

});
function ScrollExecute() {
    if ($(document).height() - 800 < ($(document).scrollTop() + $(window).height()) && $("#load_more_product").length > 0) {
        scrollNode = $('#load_more_product');
        scrollURL = $('#load_more_product a').attr("href");
        var total_pages = $('#load_more_product').attr("data-total");
        var c_page = $('#load_more_product').attr("data-current");
        if (total_pages >= c_page && scrollNode.css('display') != 'none') {
            $.ajax({
                type: 'GET',
                url: scrollURL,
                success: function (data) {
                    var filteredData = $(data).find(".list-view-items").html();
                    var load_more_button = $(data).find("#load_more_product");
                    $(".list-view-items").append(filteredData);
                    $("#load_more_product").replaceWith(load_more_button);
                    if (GRFQConfigs.show_price == '0' || GRFQConfigs.show_price == '1') {
                        $(GRFQConfigs.selector.price_selector).attr('style', 'display:none !important');
                    }
                    if (GRFQConfigs.collection_enable == !0) {
                        $('.rfq-collection-script').each(function () {
                            var id_product = $(this).data('id');
                            var is_disabled = !1;
                            $.each(GRFQConfigs.disabled_products, function (index, value) {
                                if (id_product == value) {
                                    is_disabled = !0
                                }
                            });
                            var rfq_btn = $(this).parent().find('.button.rfq-btn');
                            if (is_disabled == !1 && $(rfq_btn).length == 0) {
                                $('<button class="btn button rfq-btn rfq-collection-btn-' + GRFQConfigs.theme_store_id + '" onclick="return GRFQApp.add(this, ' + id_product + ')">' + GRFQConfigs.translations.button + '</button>').insertAfter(this);
                            }
                        });
                    }

                    if ($(window).width() > 1024) {
                        $('.product-popover-hover').imageTooltip();
                    }

                },
                dataType: "html"
            });
        }
        if (total_pages == c_page) {
            scrollNode.css('display', "none");
        }

    }
}

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getParam(p) {
    var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}


